import React from "react";

export default function ZPartnerLSC0Footer() {
    return (
        <div className="absolute-footer dark">
            <div className="container clearfix">
                <p className="float-none mb-1 text-center">©2025 Coffee Concepts Retail Co.,Ltd. All rights reserved.</p>
            </div>
        </div>
    );
}
